/* tslint:disable */
/* eslint-disable */
/**
 * merged spec
 * merged spec
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ActivityType;
(function (ActivityType) {
    ActivityType["GameSeason"] = "game_season";
    ActivityType["GamePoolPlay"] = "game_pool_play";
    ActivityType["GamePlayoff"] = "game_playoff";
    ActivityType["GameFriendly"] = "game_friendly";
    ActivityType["GameConsolation"] = "game_consolation";
    ActivityType["GameTravel"] = "game_travel";
    ActivityType["GameTournament"] = "game_tournament";
    ActivityType["GameLeague"] = "game_league";
    ActivityType["GameScrimmage"] = "game_scrimmage";
    ActivityType["GameFinal"] = "game_final";
    ActivityType["EventPractice"] = "event_practice";
    ActivityType["EventLesson"] = "event_lesson";
    ActivityType["EventTraining"] = "event_training";
    ActivityType["EventMeeting"] = "event_meeting";
    ActivityType["EventTournament"] = "event_tournament";
    ActivityType["EventLeague"] = "event_league";
    ActivityType["EventCamp"] = "event_camp";
    ActivityType["EventClass"] = "event_class";
    ActivityType["EventOther"] = "event_other";
})(ActivityType || (ActivityType = {}));
